import api from "src/shared/api";
import {
  ISwoolBaseResponse,
  IPartnersDocDepResponse,
} from "src/shared/types/api";
import {
  IPartnerContractDropdowns,
  IPartnerDropdowns,
} from "src/shared/types/dropdowns";

const partnerDropdownsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPartnerDropdowns: build.query<IPartnerDropdowns, void>({
      query: () => {
        return {
          url: `/api/dropdowns/partners`,
          method: "GET",
        };
      },
      transformResponse: (data: ISwoolBaseResponse<IPartnerDropdowns>) => {
        return data.data;
      },
    }),

    getPartnersDocDeptDropdowns: build.query<IPartnersDocDepResponse, void>({
      query: () => {
        return {
          url: `/api/partners/doc-debts/filters`,
          method: "GET",
        };
      },
      transformResponse: (
        data: ISwoolBaseResponse<IPartnersDocDepResponse>,
      ) => {
        return data.data;
      },
    }),
    getPartnerContractDropdowns: build.query<IPartnerContractDropdowns, string>(
      {
        query: (partnerId) => {
          return {
            url: `/api/dropdowns/partners/${partnerId}/contract-settings`,
            method: "GET",
          };
        },
        transformResponse: (
          data: ISwoolBaseResponse<IPartnerContractDropdowns>,
        ) => {
          return data.data;
        },
      },
    ),
    getVirtualContractDropdowns: build.query<IPartnerContractDropdowns, void>({
      query: () => {
        return {
          url: `/api/dropdowns/partners/virtual-contract-settings`,
          method: "GET",
        };
      },
      transformResponse: (
        data: ISwoolBaseResponse<IPartnerContractDropdowns>,
      ) => {
        return data.data;
      },
    }),
  }),
});

export const {
  useGetPartnerDropdownsQuery,
  useGetPartnersDocDeptDropdownsQuery,
  useGetPartnerContractDropdownsQuery,
  useGetVirtualContractDropdownsQuery,
} = partnerDropdownsApi;
